module.exports = __webpack_public_path__ + "static/media/machines.03c07316.png";